import { Injectable, Injector } from '@angular/core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { Observable } from 'rxjs';
import { IBaseResponse } from '@carm/_utils/models';

@Injectable()
export class CadLockService extends BaseApiService {

  get cadLockURL(): string {
    return `${this.endPointBP}/cad/draft`;
  }

  constructor(protected injector: Injector) {
    super(injector);
  }

  draftHeartbeat(draftUid: string): Observable<IBaseResponse> {
    const endPoint = `${this.cadLockURL}/${draftUid}/heartbeat`;
    return this.httpAuthPost<IBaseResponse>(endPoint, null);
  }

  draftUnlock(draftUid: string): Observable<IBaseResponse> {
    const endPoint = `${this.cadLockURL}/${draftUid}/unlock`;
    return this.httpAuthPost<IBaseResponse>(endPoint, null);
  }

  checkLock(draftUid: string): Observable<IBaseResponse> {
    const endPoint = `${this.cadLockURL}/${draftUid}/lockStatus`;
    return this.httpAuthPost<IBaseResponse>(endPoint, null);
  }
}
